// more or less copied from src/js/shared/fathCarouselTracking.js
// fathom will eventually be phased out completely
('use strict');
import 'vendor/jquery.isOnScreen';
import Domain from 'helpers/Domain'; // ~/src/web-package-coreui/src/js/helpers/Domain.js

if (!window.impressionTracking) {
    window.impressionTracking = {
        needToDoInitialTracking: true,
        track: null,
    };
}

export class CarouselTracking {
    static scrollIsMonitored = false;
    static scrollInterval = null;
    static totalNumberCarousels = 1; // set counter =1 for brandCarousel
    static previouslyVisibleWrappers = new Set();
    static resizing = false;

    constructor() {
        this.allWrappers = [];
        this.payload = [];
        this.metadata = {};
        this.scrollTimer = null;

        let body = document.body;
        if (body.hasAttribute('data-num-carousels')) {
            this.totalNumCarousels = parseInt(body.getAttribute('data-num-carousels'));
        }
        this.carouselCounter = 0;
    }

    static addNumCarousels(numCarousels) {
        CarouselTracking.totalNumberCarousels += numCarousels;
    }

    static removeNumCarousels(numCarousels) {
        CarouselTracking.totalNumberCarousels -= numCarousels;
    }

    addPayLoad(carousel) {
        this.payload.push(carousel);
    }

    addWrapper(wrapper) {
        this.allWrappers.push(wrapper);
    }

    buildPayObject(payObject) {
        return {
            brandPlatformId: CBS.Registry?.brandPlatformID?.toString(),
            siteEdition: CBS.Registry?.siteEdition?.toString(),
            optimizelyExp: CBS.Tracking?.utag_data?.optimizelyExp,
            pageType: CBS.Tracking?.utag_data?.pageType,
            pageViewGuid: CBS.Tracking?.utag_data?.pageViewGuid,
            searchTerm: '',
            userRegId: CBS.Registry?.user?.id?.toString() ?? '',
            userBundle: CBS.Registry?.user?.bundleStatus?.toString() ?? '',
            userStatus: CBS.Registry?.user?.sb?.toString() ?? '',
            userType: CBS.Registry?.user?.sub_status?.toString() ?? '',
            userClientRegion: CBS.Registry?.region?.property?.toString() ?? '',
            userProfileId: CBS.Registry?.user?.profile_id?.toString() ?? '',
            userProfileCategory: CBS.Registry?.user?.profile_type?.toString() ?? '',
            userProfileMaster: CBS.Registry?.user?.userProfileMaster?.toString() ?? '',
            userProfileRefId: CBS.Registry?.user?.profile_reference_id?.toString() ?? '',
            contentFeatures: payObject,
        };
    }

    buildDataFeatureObject(containerId = undefined) {
        const browseShowsGrid = {
            id: '99999',
            slug: 'all-shows',
            title: 'All Shows',
        };
        const browseMoviesGrid = {
            id: '99998',
            slug: 'all-movies',
            title: 'All Movies',
        };

        if (containerId === 'browse_shows_grid') {
            return {
                hub: [browseShowsGrid],
            };
        } else if (containerId === 'browse_movies_grid') {
            return {
                hub: [browseMoviesGrid],
            };
        }
        return {
            hub: [
                {
                    id: CBS.Tracking?.utag_data?.hubId?.toString() ?? '',
                    slug: CBS.Tracking?.utag_data?.hubSlug?.toString() ?? '',
                    title: CBS.Tracking?.utag_data?.title?.toString() ?? '',
                },
            ],
        };
    }

    enableAndResetDisplayTrackingInterval() {
        if (!CarouselTracking.scrollIsMonitored) {
            CarouselTracking.scrollIsMonitored = true; // prevents more than one scroll listener from being added
            window.addEventListener('scroll', () => {
                if (CarouselTracking.resizing) return;

                this.afterScrollStops(() => {
                    this.trackVisibleWrappers();
                }, 1000);
            });
        }
    }

    afterScrollStops(callback, waitTimeInMS) {
        let pageYOffset = window.pageYOffset;
        if (CarouselTracking.scrollInterval === null) {
            // prevents additional scrolling from creating additional intervals
            CarouselTracking.scrollInterval = setInterval(() => {
                if (pageYOffset === window.pageYOffset) {
                    clearInterval(CarouselTracking.scrollInterval);
                    callback();
                    CarouselTracking.scrollInterval = null;
                } else {
                    pageYOffset = window.pageYOffset;
                }
            }, waitTimeInMS);
        }
    }

    getVisibleWrappers() {
        return this.allWrappers
            .filter((element) => element.isOnScreen(0.2, 0.2))
            .map((element) => this.getPayloadByDisplayID(element.data('displayid')))
            .filter((payload) => typeof payload !== 'undefined');
    }

    trackVisibleWrappers() {
        const payloads = this.getVisibleWrappers();
        this.trackWrappers(payloads);
    }

    trackWrappers(payloads) {
        payloads = payloads.filter((payload) => payload.items.length > 0);
        if (payloads.length > 0) {
            this.trackObject(this.buildPayObject(this.sortPayLoads(payloads)), 'carouselView');
        }
    }

    getAllWrappers() {
        return this.allWrappers;
    }

    getPayloadByDisplayID(id) {
        return this.payload.find((obj) => obj.displayId === id);
    }

    getPayload() {
        return this.payload;
    }

    sortPayLoads(payloads) {
        return payloads.sort((a, b) => {
            return a.position - b.position;
        });
    }

    trackObject(obj, eventType) {
        if (!this.suppressTracking() && typeof om != 'undefined') {
            let eventData = {
                type: eventType,
                data: {
                    feature: this.buildDataFeatureObject(obj?.contentFeatures[0]?.containerId),
                    pplus: this.reindexPosition(obj),
                },
            };
            om.sendEvent(eventData);
        }
    }

    deviceType() {
        if (CBS.Tracking.utag_data.deviceType == 'desktop')
            return $('body').attr('touch-enabled') == 'true' ? 'tablet_web' : 'desktop_web';
        else if (CBS.Tracking.utag_data.deviceType == 'mobile') return 'mobile_web';
        return '';
    }

    suppressTracking() {
        return (
            CBS.Registry.user.profile_type == 'YOUNGER_KIDS' ||
            CBS.Registry.user.profile_type == 'KIDS' ||
            window.location.href.includes('user-profile')
        );
    }

    reindexPosition(obj) {
        let result = JSON.parse(JSON.stringify(obj));
        // There is a bug that is sending the first 2 grids/carousels at position 0
        // if (result?.payload)
        //     for (let key in result.payload)
        //         if (result.payload[key]?.position)
        //             result.payload[key].position = result.payload[key].position - 1;
        return result;
    }
}

export default class ImpressionTracking {
    static needToDoInitialTracking = true;
    static resizeTimeout = null;

    constructor(wrapper, swiper) {
        this.wrapper = wrapper;
        this.swiper = swiper;
        this.previouslyTrackedContent = new Set();

        if (window.impressionTracking.track === null) {
            window.impressionTracking.track = new CarouselTracking();
            window.impressionTracking.track.enableAndResetDisplayTrackingInterval();
        }
        const payload = this.buildPayLoad();
        if (!payload || payload.items === undefined) {
            return;
        }
        window.impressionTracking.track.addWrapper(wrapper);
        window.impressionTracking.track.addPayLoad(payload);

        // Track initial carousels
        if (window.impressionTracking.needToDoInitialTracking) {
            window.impressionTracking.needToDoInitialTracking = false;
            setTimeout(() => {
                window.impressionTracking.track.trackVisibleWrappers();
            }, 3000);
        }
    }

    buildPayLoad(clickedEl = null) {
        const container = this.wrapper.parents('.js-le-carousel');
        if (!container) {
            return null;
        }

        const isHighlightEnabled = container.data('iscontenthighlightenabled');
        const carouselId = container.data('carouselid');
        if (!container.data('displayid') || !container.data('recoid') || !container.data('title')) {
            return null;
        }
        this.display_id = container.data('displayid')?.toString() ?? '';

        let payload = {
            position: container?.data('position').toString() ?? '',
            containerId: carouselId ?? '',
            containerTitle: container?.data('title')?.toString() ?? '',
            containerType:
                container?.data('model')?.toString() ?? container?.data('type')?.toString() ?? '',
            displayId: this.display_id,
            rowNum: container?.data('position') ? Number(container?.data('position')) : '0', // start impression index at "0"
            rankModel: container?.data('rankmodel')?.toString() ?? '',
            pvrModel: container.find('.video-carousel-box')?.data('pvrmodel')?.toString() ?? '',
            items: clickedEl ? this.buildClickItemContent(clickedEl) : this.buildItemContent(),
            isHighlightEnabled: isHighlightEnabled ? 'true' : 'false',
            containerStyle: container?.data('presentationstyle'),
            containerItemTotal: container?.data('total')?.toString() ?? '',
        };

        // add extra params for spotlight carousel
        if (payload.containerType == 'promotion') {
            let dataImpression = $(container).find('a.link').data('impression').split('|');
            payload.containerStyle = dataImpression[4].toString() ?? '';
        }

        return payload;
    }

    addNewItem(content = [], dataImpression) {
        const container = this.wrapper.parents('.js-le-carousel');
        if (!container) {
            return null;
        }
        const carouselId = container.data('carouselid');
        if (!container.data('displayid') || !container.data('recoid') || !container.data('title')) {
            return null;
        }

        let newItem = {
            id: dataImpression[0]?.toString(),
            title: dataImpression[5]?.toString(),
            type: dataImpression[3]?.toString(),
            position: parseInt(dataImpression[2]),
            badgeLabel: dataImpression[8]?.toString(),
            isUnlocked: !(dataImpression[9] === 'true'),
            cmsId: dataImpression[10]?.toString(),
            contentStatus: dataImpression[11]?.toString() ?? false,
        };

        // add extra params for spotlight carousel
        if (dataImpression[4] == 'spotlight') {
            let spotlightItem = {
                streamStartTimestamp: dataImpression[13]?.toString() ?? '',
                streamEndTimestamp: dataImpression[14]?.toString() ?? '',
                videoId: dataImpression[12]?.toString() ?? '',
                contentStatus: dataImpression[15]?.toString() ?? '',
                type: dataImpression[3]?.toString() ?? '',
                isUnlocked: '',
            };
            newItem = { ...newItem, ...spotlightItem };
        }

        // blank isUnlocked for promo tiles
        if (newItem.type.indexOf('promo') !== -1) {
            newItem.isUnlocked = '';
        }

        content.push(newItem);
        return content;
    }

    buildClickItemContent(clickedEl = null) {
        let content = [];
        let dataImpression = $(clickedEl.currentTarget)
            .find('a.link')
            .data('impression')
            .split('|');
        return this.addNewItem(content, dataImpression);
    }

    buildItemContent() {
        if (this.swiper.slides.length) {
            let content = [];
            for (const slide in this.swiper.slides) {
                let s = this.swiper.slides[slide];
                if (s && typeof s === 'object') {
                    let $s = $(s);
                    if ($s.hasClass('swiper-slide-visible')) {
                        let dataImpression = $s.find('a.link').data('impression').split('|');
                        let contentId = dataImpression[0]?.toString() ?? '';
                        this.addNewItem(content, dataImpression);
                        this.previouslyTrackedContent.add(contentId);
                        this.setPayloadClick(
                            $s,
                            this.display_id,
                            contentId,
                            dataImpression[5]?.toString(),
                        );
                    }
                } else {
                    break;
                }
            }
            return content;
        }
    }

    clickEvent(event) {
        window.impressionTracking.track.trackObject(
            window.impressionTracking.track.buildPayObject([event.data.this.buildPayLoad(event)]),
            'carouselSelect',
        );
    }

    setPayloadClick(slide, displayId, contentId, contentTitle) {
        slide.off('click', this.clickEvent).on('click', { this: this }, this.clickEvent);
    }

    updateImpressionResizePerCarousel(position) {
        return window.impressionTracking.track.getPayload().filter((x) => {
            if (parseInt(x.position) === parseInt(position)) {
                return (x.items = this.buildItemContent());
            }
        });
    }

    updateImpressionResize() {
        if (ImpressionTracking.resizeTimeout !== null)
            clearTimeout(ImpressionTracking.resizeTimeout);
        ImpressionTracking.resizeTimeout = setTimeout(() => {
            window.impressionTracking.track.trackVisibleWrappers();
        }, 300);
    }

    updateImpressionTracking(position) {
        let obj = this.updateImpressionResizePerCarousel(position);
        if (obj && obj.length > 0 && obj[0].items && obj[0].items.length > 0) {
            window.impressionTracking.track.trackObject(
                window.impressionTracking.track.buildPayObject(obj),
                'carouselView',
            );
        }
    }

    updateImpressionTrackingMarquee(obj, action = 'marqueeView') {
        if (obj && obj.length && obj[0]?.items && obj[0]?.items.length > 0) {
            window.impressionTracking.track.trackObject(
                window.impressionTracking.track.buildPayObject(obj),
                action,
            );
        }
    }
}

/**
 * Checking if CBS.Registry.pageType or window.location.href are available for Tracking
 * @param {object[]} pageList - {pageType: 'HOMEPAGE', href: '/home'}
 * @return {boolean}
 */
export const isPageAvailableForTracking = (pageList = null) => {
    if (pageList === null) {
        pageList = [
            {
                pageType: 'HOMEPAGE',
                href: '/home',
            },
            {
                pageType: 'Search',
                href: '/search',
            },
            {
                pageType: 'hubs_collection',
                href: '/collections',
            },
            {
                pageType: 'hubs_collection',
                href: '/movies',
            },
            {
                pageType: 'CATEGORY_DOOR',
                href: '/movies',
            },
            {
                pageType: 'CATEGORY_DOOR',
                href: '/browse',
            },
            {
                pageType: 'BRANDS',
                href: '/brands',
            },
            {
                pageType: 'SHOWHOME',
                href: '/news',
            },
        ];
    }
    return (
        pageList.find(
            (pageType) =>
                CBS.Registry.pageType === pageType.pageType ||
                window.location.href.indexOf(pageType.href) !== -1,
        ) !== undefined
    );
};

export const hasImpressionTracking = (
    isFathomHost = false,
    isAvailableForTracking = isPageAvailableForTracking,
) => {
    if (isFathomHost)
        return CBS.Registry.fathomHost && CBS.Registry?.user?.id && isAvailableForTracking();

    return CBS.Registry?.user?.id && isAvailableForTracking();
};
